import { handlerGetUrlParams } from '@/utils/dealUrlParams.js'
import request from '@/utils/request'

export function getDemandList(param) {
  const url = handlerGetUrlParams('/bus/demands/list', param)
  return request({
    url,
    method: 'GET'
  })
}

export function getDemandInfos(id) {
  return request({
    url: `/bus/demands/${id}`,
    method: 'GET'
  })
}

export function getUserInfo() {
  return request({
    url: '/system/user/getUserInfo',
    method: 'GET'
  })
}

export function deleteDemandInfos(ids) {
  return request({
    url: `/bus/demands/del/${ids}`,
    method: 'DELETE'
  })
}

// 发布/下架公告
export function issueDemandInfos(ids) {
  return request({
    url: `/bus/demands/status`,
    method: 'PUT',
    data: ids
  })
}

// 获取数量统计
export function getCounts() {
  return request({
    url: '/bus/demands/counts',
    method: 'GET'
  })
}

// // 下架公告
// export function dropDemandInfos(ids) {
//   return request({
//     url: `/bus/information/drop`,
//     method: 'PUT',
//     data: ids
//   })
// }